import { abstractLitigationCaseValidators } from "../AbstractLitigationCase/abstractLitigationCaseValidators";

export const contractValidators = {
  ...abstractLitigationCaseValidators,
};
